import React from "react";
import { Dropdown } from "react-bootstrap";
import { WorkspaceSettingsPages } from "@components/settings/constants";
import { SettingsDropdownItem } from "./SettingsDropdownItem";

export const WorkspaceSettingsItems: React.FC = () => (
    <>
        <Dropdown.Header>Workspace</Dropdown.Header>
        <SettingsDropdownItem path={WorkspaceSettingsPages.MEMBERS}>
            Members
        </SettingsDropdownItem>
        <SettingsDropdownItem path={WorkspaceSettingsPages.INTEGRATIONS}>
            Integrations
        </SettingsDropdownItem>
        <SettingsDropdownItem path={WorkspaceSettingsPages.DIRECTORY}>
            Directory
        </SettingsDropdownItem>
        <SettingsDropdownItem path={WorkspaceSettingsPages.LOCKS}>
            Locks
        </SettingsDropdownItem>
        <SettingsDropdownItem path={WorkspaceSettingsPages.PLANS}>
            Plans
        </SettingsDropdownItem>
        <SettingsDropdownItem path={WorkspaceSettingsPages.BILLING}>
            Billing
        </SettingsDropdownItem>
    </>
);
